import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { GeocodingConfig } from '~src/geocoding/requests/GeocodingConfigRequests';

import { GeocodingRecordDGConstants } from '../recordDialog/GeocodingRecordDataGrid';

export class GeocodingRecordNameCellFormatter extends React.Component<BodyCell.Props> {
    private handleNameClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, config: GeocodingConfig) => {
        e.preventDefault();
        this.props.row.data[GeocodingRecordDGConstants.HandleEdit](config);
    };

    public render(): JSX.Element {
        const rowData = this.props.row.data;
        const configObj: GeocodingConfig = rowData[GeocodingRecordDGConstants.GeocodingConfigObj];
        const name = configObj.name;
        return (
            <TextLinkWidget
                kind={TextLinkKind.Standalone}
                testId='geocoding-config-name'
                onClick={(e) => { this.handleNameClick(e, configObj); }}
                target='_blank'>
                    {name}
            </TextLinkWidget>
        );
    }
}
